<template>
  <div
    class="active-list-container dzclubs-all-wrap"
    :style="{ height: list.data.length > 0 ? 'auto' : '100%' }"
  >
    <div
      class="list-items"
      v-for="item in list.data"
      :key="item.aid"
      :style="{ width: $route.name === 'Active' ? '96%' : '100%' }"
    >
      <ListLayout>
        <template #left>
          <div class="left-container">
            <ListImage
              :url="'https://clubs.xinmin.cn/' + item.icon"
              :size="100"
            />
            <ActiveListTag :tags="item.regist_status" />
          </div>
        </template>
        <template #right>
          <div class="right-container">
            <div class="right-top-container">
              <el-text class="list-title" tag="b" line-clamp="2">{{
                item.title
              }}</el-text>
            </div>
            <div class="right-bottom-container">
              <div class="right-bottom-box">
                <KyIcon
                  type="location"
                  color="#ee5f5c"
                  class="active-icon-container"
                >
                </KyIcon>
                <el-text truncated class="list-address">
                  {{ item.address }}
                </el-text>
              </div>
              <div class="right-bottom-box">
                <KyIcon
                  type="dateTime"
                  color="#ee5f5c"
                  class="active-icon-container"
                >
                </KyIcon>
                <el-text class="list-time">
                  {{ formatDate(item.active_begin_time) }}
                </el-text>
              </div>
              <div class="list-status-container">
                <div
                  class="progress-container"
                  v-if="item.regist_status === 1 && item.number != item.total"
                >
                  <el-progress
                    :stroke-width="8"
                    :percentage="percentage(item.number, item.total)"
                    :show-text="false"
                  ></el-progress>
                </div>
                <el-text
                  class="list-status"
                  :style="{
                    visibility:
                      item.regist_status < 3 && item.regist_status != 0
                        ? ''
                        : 'hidden',
                  }"
                >
                  {{
                    item.number === item.total
                      ? "报名人数已满"
                      : item.number + "人已报名"
                  }}
                </el-text>
                <el-button type="danger" size="small" round class="list-button">
                  <router-link
                    :to="{ name: 'ActiveDetail', params: { aid: item.aid } }"
                    >活动详情</router-link
                  >
                </el-button>
              </div>
            </div>
          </div>
        </template>
      </ListLayout>
    </div>
  </div>
</template>
<script>
import { percentage, formatDate } from "@/utils";
import ListLayout from "@/components/ListLayout";
import ListImage from "@/components/ListImage";
import KyIcon from "@/components/KyIcon";
import ActiveListTag from "./ActiveListTag";
export default {
  components: {
    ListLayout,
    ListImage,
    ActiveListTag,
    KyIcon,
  },
  props: {
    list: {
      type: Object,
    },
  },
  methods: {
    percentage,
    formatDate,
  },
};
</script>
<style lang="less" scoped>
@import "~@/styles/mixin.less";

.dzclubs-all-wrap {
  background-color: transparent;
  padding-top: 0;
  .list-items {
    background-color: var(--fff);
    margin: 10px auto;
    .list-layout-container {
      padding: 10px 0;
      margin: auto;
      width: 96%;
    }
    .left-container {
      position: relative;
      overflow: hidden;
      .list-image-container {
        margin-bottom: 5px;
      }
    }
    .right-container {
      position: relative;
      margin-left: 10px;
      height: 100%;
      .right-top-container {
        .self-flex(flex-start);
        margin-bottom: 10px;
        .el-tag {
          margin-right: 10px;
        }
        .list-title {
          letter-spacing: 1px;
          font-size: 16px;
          text-align: left;
          line-height: normal;
          color: rgba(0, 0, 0, 0.7);
        }
      }
      .right-bottom-container {
        display: block;
        .right-bottom-box {
          .self-flex(flex-start);
          align-items: center;
          margin-bottom: 5px;
          .list-address,
          .list-time {
            font-size: 14px;
            text-align: left;
          }
        }
        .list-status-container {
          .self-flex(flex-start);
          position: absolute;
          left: 0;
          bottom: 0;
          margin-bottom: 0;
          width: 100%;
          .progress-container {
            .self-flex();
            align-items: center;
            min-width: 60px;
            flex: 1 1 auto;

            margin-right: 5px;
          }
          .el-progress--line {
            width: 100%;
          }
          .list-status {
            flex: 1 1 auto;
            margin-right: 5px;
            text-align: left;
            overflow: hidden;
            word-break: normal;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-size: 12px;
          }
          a,
          a:hover {
            color: inherit;
          }
        }
      }
    }
  }
  .active-icon-container {
    .active-icon(15px);
    margin-right: 10px;
    flex: 0 0 auto;
  }

  .left-container .active-list-tag-container {
    .self-flex(center);
  }
}
</style>